module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }